import get from 'lodash.get';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectOrderBatchIds = (state) => get(state, 'orderBatches', emptyArray);
export const selectShipmentBatchIds = (state) => get(state, 'shipmentBatches', emptyArray);
